import { useSignupDirectCtx } from 'domains/signupDirect/context';
import { useTrack } from 'utils/hooks/useMixPanel';
import { JotformRedirectReason } from 'domains/signupDirect/misc/jotform/urls';
import { DIRECT_SIGNUP_MIXPANEL_EVENTS, EVAL_EXCLUSION_REASONS } from 'domains/signupDirect/misc/mixpanelTracking';

type DualBailoutExclusionReasons =
  | typeof EVAL_EXCLUSION_REASONS.DESIRED_TIMESLOTS_NOT_AVAILABLE
  | typeof EVAL_EXCLUSION_REASONS.HAS_QUESTION;

export const useOnBailout = (reason: DualBailoutExclusionReasons, redirectReason: JotformRedirectReason) => {
  const { track } = useTrack();
  const { onContinueToJotformRegistrationForm } = useSignupDirectCtx();

  return () => {
    track(
      DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.EVAL.EXCLUSION,
      {
        reason,
        step: DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.EVAL.TIMESLOTS,
      },
      { send_immediately: true },
    );

    return onContinueToJotformRegistrationForm(redirectReason);
  };
};

export const useOnBailoutDueToAvailability = () =>
  useOnBailout(
    EVAL_EXCLUSION_REASONS.DESIRED_TIMESLOTS_NOT_AVAILABLE,
    JotformRedirectReason.NEEDS_DIFFERENT_AVAILABILITY,
  );

export const useOnBailoutDueToQuestion = () =>
  useOnBailout(EVAL_EXCLUSION_REASONS.HAS_QUESTION, JotformRedirectReason.HAS_QUESTION);
